// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"773e9032","866":"51db68e3"}[chunkId] + ".chunk.js";
};